/**
 * Utilidades para generar URLs amigables para SEO
 */

/**
 * Convierte un nombre de usuario en un slug URL amigable
 * @param username Nombre de usuario a convertir
 * @returns Slug URL amigable
 */
export const generateUserSlug = (username: string): string => {
  if (!username) return '';
  
  return username
    .toLowerCase()
    .replace(/[^\w\s]/gi, '') // Eliminar caracteres especiales
    .replace(/\s+/g, '-') // Reemplazar espacios con guiones
    .replace(/-+/g, '-') // Evitar múltiples guiones seguidos
    .replace(/^-+|-+$/g, ''); // Eliminar guiones al inicio y final
};

/**
 * Genera una URL amigable para un perfil de usuario
 * @param userId ID del usuario
 * @param username Nombre de usuario
 * @returns URL amigable para SEO
 */
export const getUserProfileUrl = (userId: string, username: string): string => {
  const slug = generateUserSlug(username);
  return `/usuario/${slug || userId}`;
};

/**
 * Genera una URL amigable para un hashtag
 * @param tag Hashtag sin el símbolo #
 * @returns URL amigable para SEO
 */
export const getHashtagUrl = (tag: string): string => {
  return `/hashtag/${tag.toLowerCase()}`;
};

/**
 * Obtiene la URL completa incluyendo el dominio
 * @param path Ruta relativa
 * @returns URL completa
 */
export const getFullUrl = (path: string): string => {
  const baseUrl = 'https://domired.top';
  return `${baseUrl}${path.startsWith('/') ? path : `/${path}`}`;
};
